import { toast } from 'react-hot-toast';
import { useUpdateCommunityDraftMutation } from 'generated/graphql';

export const useUpdateDraft = () =>
  useUpdateCommunityDraftMutation({
    // Drafts and scheduled posts share this mutation, so the message cannot
    // name either one.
    onCompleted: () => toast.success('Post updated'),
    onError: () => toast.error('Something went wrong'),
  });
